import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Agreement, AgreementStatus } from '../../types';
import { agreementApi } from '../services/agreements';

export interface AgreementItemState {
  agreement?: Agreement;
  agreementId?: string;
}

const initialState: AgreementItemState = {
  agreement: undefined,
  agreementId: undefined,
};

export const agreementItemSlice = createSlice({
  name: 'agreementItem',
  initialState,
  reducers: {
    clearAgreementState: (state) => {
      state.agreement = undefined;
      state.agreementId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      agreementApi.endpoints.getAgreement.matchFulfilled,
      (state, action: PayloadAction<{ data: Agreement }>) => {
        state.agreement = {
          ...action.payload.data,
          status: action.payload.data.archivedAt
            ? AgreementStatus.ARCHIVED
            : AgreementStatus.PUBLISHED,
        };

        state.agreementId = action.payload.data.id;
      },
    );
    builder.addMatcher(
      agreementApi.endpoints.changeAgreementsStatus.matchFulfilled,
      (state) => {
        if (state.agreementId) {
          state.agreement = {
            ...state.agreement,
            status: AgreementStatus.ARCHIVED,
          } as Agreement;
        }
      },
    );
  },
});

export const { clearAgreementState } = agreementItemSlice.actions;

export default agreementItemSlice.reducer;
